<div class='container'>
    <div class='row'>
        <div class='col-md-12 col-12'>
                <p>Account</p>
        </div>
    </div>
</div>